import { useMyUserData } from 'src/shared/features/users/api/accounts/use-my-user'

export const useIsCurrentUser = (userId: number) => {
  const { data: currentUser } = useMyUserData()
  return currentUser?.id === userId || false
}
